import chroma from 'chroma-js';
import { type ClassValue, clsx } from 'clsx';
import type { CSSProperties } from 'react';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx('atomic-ui', ...inputs));
}

export function toTitleCase(str: string): string {
  return str
    .toLowerCase()
    .split(' ')
    .map((word: string) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
}

const CONTRAST_THRESHOLD = 2.5;
const LIGHT_TEXT = '#ffffff'; // bg-neutral - todo: what do we do with this re theming?
const DARK_TEXT = '#14143A'; // bg-primary - todo: what do we do with this re theming?

/**
 * Get an accessible text color (light or dark) based on background color.
 * Uses WCAG contrast ratio to determine the best text color for readability.
 */
export function getAccessibleTextColor(backgroundColor: string): string {
  if (!chroma.valid(backgroundColor)) {
    return DARK_TEXT;
  }

  return chroma.contrast(backgroundColor, LIGHT_TEXT) > CONTRAST_THRESHOLD
    ? LIGHT_TEXT
    : DARK_TEXT;
}

/**
 * Resolve the inline style for a colour-filled cell: the supplied background
 * colour plus a WCAG-accessible text colour. Pure (not a hook) so it can be
 * called conditionally — e.g. only when a colour is present. Shared by
 * `ColoredCell` and by non-div consumers (such as the button-based
 * `RatingToggle`) that need the same colour logic without the div wrapper.
 */
export function getColoredCellStyle(
  color: string
): Pick<CSSProperties, 'backgroundColor' | 'color'> {
  return { backgroundColor: color, color: getAccessibleTextColor(color) };
}
